import { useNotification } from '../../context/NotificationContext'
import '../../styles/userEntry.scss'
import { useState } from 'react'
import LoaderBtn from '../LoaderBtn/LoaderBtn'
import { sendCodeRegular } from '../../api/requests'
import { NavLink, useNavigate } from 'react-router-dom'
import 'animate.css'


const ForgotPassword = () => {
    const { notify } = useNotification()
    const navigate=useNavigate()

    const [inputData, setInputData] = useState({
        email: ''
    })

    const [isLoading, setLoader] = useState(false)

    function isValidEmail(email: string) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }


    const handleInput = (key: string, value: string | boolean) => {

        setInputData((prev) => {
            return {
                ...prev,
                [key]: value
            }
        })

    }

    const handleRecover = async () => {

        if (inputData.email === '') {
            notify.error('Please fill in required fields')
            return
        }

        if (!isValidEmail(inputData.email)) {
            notify.error('Enter valid e-mail address')
            return
        }


        try {
            setLoader(true)

            let resp = await sendCodeRegular(inputData.email)

            if(resp){

                 let stateData = {
                    email: inputData.email,
                    afterVerificationUrl: '/signin/resetpassword'
                }

                navigate('/signin/verify', {
                    state: stateData
                });


            }
        
    } catch (error: any) {

            notify.error(error.message)

        } finally {

        }





    }


    return (
        <div className="sectionarea" >

            <div className='content animate__animated animate__fadeIn animate__fast'>
 <NavLink to={'/'}>
                <div className='logoArea'>
                    <div className='icon logo_initials'></div>
                    <div className='icon logo_name'></div>
                </div>
                </NavLink>

                <div className='intro'>
                    <div className='title'>Forgot Password</div>
                    <div className='text'>Please provide us with the email address associated with your account. We will sent an email to help you reset your password.</div>
                </div>


                <div className='inputArea'>

                    <div className='inputPack'>
                        <label className='inputTitle'>Email Address</label>
                        <input className='inputBox' type='email' value={inputData.email} onChange={(ev) => handleInput('email', ev.currentTarget.value)}></input>
                    </div>

                </div>

                <div className='btn_grid'>
                    <LoaderBtn className={'btn'} text={'Recover Account'} isLoading={isLoading} clickFunction={handleRecover} ></LoaderBtn>
                </div>



            </div>

        </div>
    )
}


export default ForgotPassword;